import { Typography } from "@mui/material";
import { blue } from "@mui/material/colors";
import React from "react";

export const IsCreditNote = ({ account = {}, hide = false }) => {
  return (
    <>
      {account?.isCreditNote && (
        <Typography
          variant="subtitle1"
          sx={{
            color: blue[500],
            fontWeight: "bold",
          }}
        >
          Las notas de crédito están habilitadas para esta cuenta.
        </Typography>
      )}
    </>
  );
};
